// Template269: Pekín - Día 2 p.2 (Dia2MapaPalacioPekin.jsx)
// Cabecera, mapa iframe + botón Ver mapa grande + tip + sticker, bloque Colina de la Longevidad, Cómo llegar.

import React, { useState, useEffect } from "react";
import { Box } from "@mui/material";
import { useWindowSize } from "@uidotdev/usehooks";
import SabiasQue from "../SabiasQue";
import { useMapFullscreen } from "../../context/MapFullscreenContext";

const Template269 = ({
	backgroundColor,
	headerBackgroundColor,
	headerTextColor,
	fontFamily,
	page,
}) => {
	const size = useWindowSize();
	const isSmallScreen = size.width <= 600;
	const [fullscreen, setFullscreen] = useState(false);
	const { setMapFullscreen } = useMapFullscreen() || {};

	useEffect(() => {
		if (typeof setMapFullscreen === "function") {
			setMapFullscreen(fullscreen);
			return () => setMapFullscreen(false);
		}
	}, [fullscreen, setMapFullscreen]);

	const headerText = page?.texts?.[0]?.content;
	const tipMap = page?.texts?.[1]?.content;
	const title1 = page?.texts?.[2]?.content;
	const body1 = page?.texts?.[3]?.content;

	const getImageSrc = (id) => {
		if (page?.images && Array.isArray(page.images)) {
			const found = page.images.find((img) => img?.id === id);
			if (found?.src) return found.src;
		}
		return undefined;
	};
	const getCanvasImageUrl = (id) => {
		if (page?.canvasImages && Array.isArray(page.canvasImages)) {
			const found = page.canvasImages.find((img) => img?.id === id);
			if (found?.imageUrl) return found.imageUrl;
		}
		return undefined;
	};

	const img1 = getImageSrc("img1");
	const stickerMap = getImageSrc("sticker");
	const logoImage = getCanvasImageUrl("logo");
	const mapUrl = page?.maps?.[0] || "";

	const sabiasQue = Array.isArray(page?.data?.sabiasQue)
		? page.data.sabiasQue
		: [];
	const comoLlegar = page?.data?.comoLlegar;
	const actualHeaderColor = headerBackgroundColor || "#8c1d18";

	const estiloH3 = {
		fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
		fontSize: 14,
		fontWeight: 700,
		textTransform: "uppercase",
		margin: 0,
	};
	const estiloP = {
		fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
		fontSize: 13,
		color: "#444",
		margin: 0,
	};

	if (fullscreen && mapUrl) {
		return (
			<div
				style={{
					position: "fixed",
					top: 0,
					left: 0,
					right: 0,
					bottom: 0,
					height: "100%",
					backgroundColor: "#fff",
					zIndex: 9999,
					display: "flex",
					flexDirection: "column",
				}}
			>
				<div
					style={{
						padding: "10px",
						textAlign: "right",
						backgroundColor: "#C41E3A",
						flexShrink: 0,
					}}
				>
					<button
						onClick={() => setFullscreen(false)}
						style={{
							backgroundColor: "#fff",
							color: "#24221a",
							border: "none",
							borderRadius: "8px",
							padding: "6px 12px",
							fontWeight: 600,
							cursor: "pointer",
							fontFamily: "'Poppins', sans-serif",
						}}
					>
						← Volver a la guía
					</button>
				</div>
				<iframe
					title="Mapa grande Palacio de Verano"
					src={mapUrl}
					style={{
						border: 0,
						flex: 1,
						width: "100%",
						height: "100%",
						minHeight: 0,
					}}
					allowFullScreen
					loading="lazy"
				/>
			</div>
		);
	}

	return (
		<Box
			sx={{
				display: "flex",
				flexDirection: "column",
				height: "100%",
				backgroundColor: backgroundColor || "#f7f7f7",
				fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
				"& *": {
					fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
				},
			}}
		>
			<Box
				data-block-id="header"
				data-template-header
				sx={{
					backgroundColor: actualHeaderColor,
					color: headerTextColor || "#fff",
					textAlign: "center",
					padding: "15px 0",
					fontSize: "14px",
					fontWeight: 600,
					flexShrink: 0,
					position: "sticky",
					top: 0,
					zIndex: 1,
				}}
			>
				{headerText}
				{logoImage && !isSmallScreen && (
					<Box
						component="img"
						src={logoImage}
						alt="logo"
						sx={{
							width: isSmallScreen ? 66 : 80,
							position: "absolute",
							right: 2,
							top: 18,
							zIndex: 999999,
						}}
					/>
				)}
			</Box>

			{/* Mapa */}
			<Box
				data-block-id="map"
				sx={{
					flex: 1,
					minHeight: isSmallScreen ? 320 : 400,
					marginTop: "-70px",
					position: "relative",
					display: "flex",
					flexDirection: "column",
				}}
			>
				{mapUrl && (
					<>
						<iframe
							title="Mapa Palacio de Verano"
							src={mapUrl}
							style={{
								border: 0,
								flex: 1,
								width: "100%",
								minHeight: 0,
							}}
							allowFullScreen
							loading="lazy"
						/>
						<button
							onClick={() => setFullscreen(true)}
							style={{
								position: "absolute",
								top: 80,
								right: 10,
								backgroundColor: "#C41E3A",
								color: "#fff",
								padding: "8px 10px",
								fontSize: "11px",
								borderRadius: "8px",
								fontFamily: "'Poppins', sans-serif",
								boxShadow: "1px 1px 2px rgba(0,0,0,0.2)",
								zIndex: 4,
								border: "none",
								cursor: "pointer",
							}}
						>
							Ver mapa grande
						</button>
					</>
				)}
				{tipMap && (
					<Box
						sx={{
							position: "absolute",
							bottom: isSmallScreen ? 60 : 75,
							left: 18,
							backgroundColor: "#fff8db",
							border: "2px solid #f5c400",
							borderRadius: "16px 16px 16px 0px",
							padding: "10px 12px",
							fontSize: 11,
							color: "#444",
							boxShadow: "2px 2px 4px rgba(0,0,0,0.15)",
							maxWidth: isSmallScreen ? 140 : 200,
							zIndex: 3,
						}}
					>
						{tipMap}
					</Box>
				)}
				{stickerMap && (
					<img
						src={stickerMap}
						alt="sticker"
						style={{
							width: 100,
							position: "absolute",
							bottom: 0,
							left: -10,
							zIndex: 2,
						}}
					/>
				)}
			</Box>

			{/* Colina de la Longevidad + Cómo llegar */}
			<Box
				data-block-id="text-1"
				sx={{
					padding: "10px 12px",
					paddingBottom: "5px",
					position: "relative",
				}}
			>
				<Box
					data-block-id="text-2"
					sx={{
						display: "flex",
						flexDirection: "column",
						gap: 1.5,
						marginTop: 1.25,
					}}
				>
					{title1 && (
						<Box data-block-id="text-3" sx={{ display: "flex", gap: 2, position: "relative" }}>
							{img1 && (
								<Box
									component="img"
									src={img1}
									alt=""
									sx={{
										width: "40%",
										height: 110,
										objectFit: "cover",
										borderRadius: "12px",
									}}
								/>
							)}
							{sabiasQue[0] && (
								<Box sx={{ position: "absolute", top: -10, left: "32%" }}>
									<SabiasQue
										icono={sabiasQue[0].icono}
										texto={sabiasQue[0].texto}
									/>
								</Box>
							)}
							<Box sx={{ width: "60%" }}>
								<Box component="h3" sx={estiloH3}>
									{title1}
								</Box>
								{body1 && (
									<Box component="p" sx={estiloP}>
										{body1}
									</Box>
								)}
							</Box>
						</Box>
					)}

					{comoLlegar && (
						<Box
							data-block-id="text-4"
							sx={{
								backgroundColor: "#fde1e0",
								border: "3px solid",
								borderColor: actualHeaderColor,
								borderRadius: "12px",
								padding: "8px 20px",
								fontSize: 13,
								color: "#333",
								marginBottom: isSmallScreen ? 1.5 : 0,
							}}
						>
							<Box
								component="h4"
								sx={{
									margin: 0,
									marginBottom: 1,
									fontSize: 13,
									fontWeight: 700,
									color: actualHeaderColor,
									textTransform: "uppercase",
								}}
							>
								Cómo llegar al Palacio de Verano
							</Box>
							<Box
								component="ul"
								sx={{ paddingLeft: 2.5, margin: 0, lineHeight: 1.6 }}
								dangerouslySetInnerHTML={{ __html: comoLlegar }}
							/>
						</Box>
					)}
				</Box>
			</Box>
		</Box>
	);
};

Template269.thumbnail = "/images/template-1.png";
export default Template269;
